import compact from "lodash/compact";
import isArray from "lodash/isArray";
import reverse from "lodash/reverse";
import { PropsWithChildren } from "react";

import css from "./assessment_checkmarks.module.scss";

type AssessmentCheckmarksProps = {
  title: string;
};

export const AssessmentCheckmarks = ({ children, title }: PropsWithChildren<AssessmentCheckmarksProps>) => {
  const icons = reverse(compact(isArray(children) ? children : [children]));

  return (
    <div className={css.leftIconsContainer}>
      {icons.map((icon, i) => (
        <div key={`${title}-${i}`} className={css.leftIconWrapper}>
          {icon}
        </div>
      ))}
    </div>
  );
};
